export default __webpack_public_path__ + "static/media/Icon-send.2a227de8.svg";